import React from 'react';
import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import { formatNotifications } from 'controllers/notifications/formatNotifications';
import { LeadsNotification } from './notificationTypes/leadsNotification';
import { ApplicantsNotification } from './notificationTypes/applicantsNotification';
import { MissingJobFieldsNotification } from './notificationTypes/missingJobFieldsNotification';

const useStyles = makeStyles({
  NotificationsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 19px',
    height: 'calc(100vh - 54px)',
    overflow: 'auto',
  },
  dateTitle: {
    marginTop: '18px',
    color: '#49515a',
    lineHeight: 1.43,
    letterSpacing: '0.25px',
    fontSize: '14px',
    fontWeight: 'normal',
  },
  loadMoreButtonContainer: {
    padding: '38px 10px',
    textAlign: 'center',
  },
  loadMoreButton: {
    minWidth: '140px',
    height: '34.2px',
    padding: '8px 22px 7.2px 23px',
    borderRadius: '4px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#c8dad2',
    color: '#4b8c6f',
    fontSize: '14px',
    fontWeight: 500,
  },
});

export const NotificationList = ({
  notifications = [],
  loadMore,
  hasMore = false,
}) => {
  const classes = useStyles();
  const { dates, list } = formatNotifications(notifications);
  const datesArray = Object.keys(dates);

  const renderNotification = (notification) => {
    if (notification.notificationType === 'APPLICANTS_NOTIFICATION') {
      return <ApplicantsNotification notification={notification} />;
    } else if (notification.notificationType === 'LEADS_NOTIFICATION') {
      return <LeadsNotification notification={notification} />;
    } else if (notification.notificationType === 'MISSING_JOB_FIELDS') {
      return <MissingJobFieldsNotification notification={notification} />;
    }

    return false;
  };

  return (
    <Grid item xs={12} classes={{ root: classes.NotificationsContainer }}>
      {datesArray.map((d) => (
        <>
          <Typography classes={{ root: classes.dateTitle }}>
            {dates[d]}
          </Typography>
          <Grid container>
            {list[d].map((notification) => renderNotification(notification))}
          </Grid>
        </>
      ))}
      {hasMore && (
        <div className={classes.loadMoreButtonContainer}>
          <Button classes={{ root: classes.loadMoreButton }} onClick={loadMore}>
            Load More
          </Button>
        </div>
      )}
    </Grid>
  );
};
